import { useEffect } from 'react'

export const useAsyncEffect = (f: () => Promise<undefined>, deps: any[]): void => {
	useEffect(() => {
		const doEffect = () => {
			f().then((res) => {
				if (typeof res == 'function') throw new Error(`You cannot return a clenaup function from useAsyncEffect`)
			})
		}
		const res = doEffect()

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [f, ...deps])
}
